export default __webpack_public_path__ + "static/media/pairist.1655f981.svg";